import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LifestyleRewardsApi } from '../../api/lifestyle-rewards/lifestyle-rewards.api.class';
import { InitiateLifestyleRewardsRequest } from 'src/app/interfaces/lifestyle-rewards/InitiateLifestyleRewardsRequest';

@Injectable({
  providedIn: 'root'
})
export class LifestyleRewardsService {

  constructor(private lifestyleRewardsApi: LifestyleRewardsApi) { }

  initiateTransaction(sessionToken: string, mobileNumber: string, pin: string): Observable<any> {
    const request: InitiateLifestyleRewardsRequest = {
      mobileNumber,
      pin
    };
    return this.lifestyleRewardsApi.initiateLifestyleRewards(sessionToken, request);
  }
}
